import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

@Component({
	standalone: true,
	imports: [CommonModule],
	selector: 'cpi-svg-gears',
	templateUrl: './svg-gears.component.html',
	styleUrls: ['./svg-gears.component.scss'],
})
export class SvgGearsComponent implements OnInit {
	constructor() {}

	@Input()
	gearSpinDurationMS = 4000;

	ngOnInit(): void {}
}
